import { hexToRgb } from '@mui/material/styles'

import { extractRGBValues } from '@/helpers/colorsUtil'

/**
 * Builds the onboarding `selectedPalette` object shape from a theme swatch
 * (same structure as the colors wizard uses).
 *
 * @param {string} title
 * @param {object} theme - swatch fields: primary, secondary, textPrimary, textSecondary, complementary
 * @param {string|number} [templateIndex='default']
 */
export function buildPaletteFromSwatch(title, theme, templateIndex = 'default') {
  return {
    title,
    templateIndex,
    styles: {
      preColor: {
        brand: extractRGBValues(hexToRgb(theme.primary ?? '#7392ff')),
        altBrand: extractRGBValues(hexToRgb(theme.secondary ?? '#444655')),
        text: extractRGBValues(hexToRgb(theme.textPrimary ?? '#0e0e0e')),
        textAlt: extractRGBValues(hexToRgb(theme.textSecondary ?? '#ffffff')),
        complementary: extractRGBValues(hexToRgb(theme.complementary ?? '#EBEEFF')),
      },
    },
  }
}
